export const backendUrl = 'https://adminserver.kvrwears.com';
export const storeUrl = 'https://storeserver.kvrwears.com'
